module.exports = __webpack_public_path__ + "img/illu-hole-shadow.9733746d.svg";